import React, { memo } from 'react';

import Banner from 'components/Banner';
import SeoLinksBlocks from 'components/SeoLinksBlocks';
import Subscribe from 'components/Subscribe';
import ActualCurrencyData from 'components/ActualCurrencyData';
import InfoBlock from 'components/InfoBlock';
import PropTypes from 'prop-types';

import CompaniesNews from 'components/CompaniesNews';
import Blogs from 'components/Blogs';
import { Wrapper, InfoContent } from './styles';

const PageSidebar = memo(
  ({
    isInfoContentDisplayed,
    isInfoBlockDisplayed,
    isCompaniesNewsDisplayed,
    isBlogsDisplayed,
    isActualCurrencyDataDisplayed,
  }) => {
    return (
      <Wrapper id="mc-sidebar">
        <Banner id="hp-react-banner-premium" slot="bn-slot-premium" />

        {isInfoContentDisplayed && (
          <InfoContent>
            {isInfoBlockDisplayed && <InfoBlock />}
            {isCompaniesNewsDisplayed && <CompaniesNews />}

            {isActualCurrencyDataDisplayed && <ActualCurrencyData />}
            <Subscribe />
            {isBlogsDisplayed && <Blogs />}
            <SeoLinksBlocks />
          </InfoContent>
        )}

        <Banner sticky id="hp-react-banner-sticky" slot="bn-slot-sticky-1a" />
      </Wrapper>
    );
  }
);

PageSidebar.propTypes = {
  isInfoContentDisplayed: PropTypes.bool,
  isBlogsDisplayed: PropTypes.bool,
  isInfoBlockDisplayed: PropTypes.bool,
  isCompaniesNewsDisplayed: PropTypes.bool,
  isActualCurrencyDataDisplayed: PropTypes.bool,
};

PageSidebar.defaultProps = {
  isInfoContentDisplayed: true,
  isBlogsDisplayed: false,
  isInfoBlockDisplayed: false,
  isCompaniesNewsDisplayed: false,
  isActualCurrencyDataDisplayed: true,
};

export default PageSidebar;
